// utils/autoRegister.js
import Vue from 'vue'
var componentNameArray = [];
/**
 * 自动注册 components 目录下的所有组件
 * @param {*} requireContext - require.context() 返回的对象
 */
export function autoRegisterComponents(requireContext) {
  requireContext.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireContext(fileName)
    
    // 获取组件名
    const componentName = getComponentName(fileName)
    componentNameArray.push(componentName);
    
    // 注册组件
    Vue.component(componentName, componentConfig.default || componentConfig)
  })
}

/**
 * 从文件名获取组件名
 * @param {string} fileName - 文件名
 * @returns {string} 组件名
 */
export function getComponentName(fileName) {
  // 移除开头的 './' 和文件扩展名
  const name = fileName
    .replace(/^\.\//, '')
    .replace(/\.\w+$/, '')
  
  // 转换为 PascalCase
  return name
    .split('/')
    .map(part => part.charAt(0) + part.slice(1))
    .join('')
}
export function componentInit() {
  // 注册 components 目录下的所有组件
  const requireComponent = require.context(
    '@/components/secure', // 组件目录
    true,           // 是否查询子目录
    /\.vue$/        // 匹配文件的正则
  )

  // 注册全局组件
  autoRegisterComponents(requireComponent)
}
export function getComponent() {
  return componentNameArray
}


// WEBPACK FOOTER //
// ./src/utils/autoRegister.js